// extracted by mini-css-extract-plugin
export default {"tabButtonGroup":"tab-button-group__tabButtonGroup___3OiHa"};